"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniSat = void 0;
const tools_1 = require("../../utils/tools");
class UniSat {
    constructor({ token, }, testnet = false) {
        const baseUrl = testnet ? "https://open-api-testnet.unisat.io" : "https://open-api.unisat.io";
        this.api = (0, tools_1.getAxiosInstance)({
            baseUrl,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
    }
    static convertToNormalUtxo(unisatUtxo) {
        return unisatUtxo.map((u) => ({
            address: u.address,
            txId: u.txid,
            index: u.vout,
            value: u.satoshi,
            blockNumber: u.height,
            inscriptions: u.inscriptions.map(({ inscriptionNumber, inscriptionId, moved, isBRC20 }) => ({
                inscriptionNumber,
                inscriptionId,
                moved,
                isBRC20,
            })),
        }));
    }
    getBTCBalance(address) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = (_a = (yield this.api.get(`/v1/indexer/address/${address}/balance`, {}))) === null || _a === void 0 ? void 0 : _a.data;
            return response.data;
        });
    }
    getBTCUtxo(address, cursor = 0) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = (_a = (yield this.api.get(`/v1/indexer/address/${address}/utxo-data`, {
                params: {
                    cursor,
                    size: 100,
                },
            }))) === null || _a === void 0 ? void 0 : _a.data;
            return response.data;
        });
    }
    getUtxos(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.getBTCUtxo(address);
            if (!result)
                return [];
            const utxos = result.utxo.map((tx) => ({
                address,
                txId: tx.txid,
                index: tx.vout,
                value: +tx.satoshi,
                blockNumber: +tx.height,
            }));
            return utxos;
        });
    }
    getInscriptionUtxo(address, cursor = 0) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = (_a = (yield this.api.get(`/v1/indexer/address/${address}/inscription-utxo-data`, {
                params: {
                    cursor,
                    size: 100,
                },
            }))) === null || _a === void 0 ? void 0 : _a.data;
            return response.data;
        });
    }
    getTxInfo(txId) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = (_a = (yield this.api.get(`/v1/indexer/tx/${txId}`, {}))) === null || _a === void 0 ? void 0 : _a.data;
            return response.data;
        });
    }
    getInscriptionInfo(inscriptionId) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = (_a = (yield this.api.get(`/v1/indexer/inscription/info/${inscriptionId}`, {}))) === null || _a === void 0 ? void 0 : _a.data;
            return response.data;
        });
    }
    getInscriptionsForAddress(address, cursor = 0) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = (_a = (yield this.api.get(`/v1/indexer/address/${address}/inscription-data`, {
                params: {
                    cursor,
                    size: 100,
                },
            }))) === null || _a === void 0 ? void 0 : _a.data;
            return response.data;
        });
    }
    getBrc20List() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = (_a = (yield this.api.get(`/v1/indexer/brc20/list`, {
                params: {
                    start: 0,
                    limit: 100,
                },
            }))) === null || _a === void 0 ? void 0 : _a.data;
            return response.data;
        });
    }
    getBrc20TickerInfo(ticker) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = (_a = (yield this.api.get(`/v1/indexer/brc20/${Buffer.from(ticker, "utf8").toString("hex")}/info`, {}))) === null || _a === void 0 ? void 0 : _a.data;
            return response.data;
        });
    }
    getBrc20TickerTxHistory(ticker, txId) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = (_a = (yield this.api.get(`v1/indexer/brc20/${Buffer.from(ticker, "utf8").toString("hex")}/tx/${txId}/history`, {}))) === null || _a === void 0 ? void 0 : _a.data;
            return response.data;
        });
    }
    getAddressBrc20History(address) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = (_a = (yield this.api.get(`/v1/indexer/address/${address}/brc20/history`, {}))) === null || _a === void 0 ? void 0 : _a.data;
            return response.data;
        });
    }
    getBrc20AddressBalances(address) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = (_a = (yield this.api.get(`/v1/indexer/address/${address}/brc20/summary`, {}))) === null || _a === void 0 ? void 0 : _a.data;
            return response.data;
        });
    }
    getBrc20AddressBalanceForTicker(address, ticker) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = (_a = (yield this.api.get(`/v1/indexer/address/${address}/brc20/${Buffer.from(ticker, "utf8").toString("hex")}/info`, {}))) === null || _a === void 0 ? void 0 : _a.data;
            return response.data;
        });
    }
    getBrc20AddressTransferrableInscriptions(address, ticker) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = (_a = (yield this.api.get(`/v1/indexer/address/${address}/brc20/${Buffer.from(ticker, "utf8").toString("hex")}/transferable-inscriptions`, {}))) === null || _a === void 0 ? void 0 : _a.data;
            return response.data;
        });
    }
}
exports.UniSat = UniSat;
exports.default = UniSat;
//# sourceMappingURL=unisat.api.js.map